import { useContext } from "react";
import { renderRichText } from "../../utils";
import MintArticle  from "./MintArticle";
import ScreenFrameGrid from "../ScreenFrameGrid";
import { FooterRoot } from "./FooterMap.styled";
import { AppContext } from "../../providers/AppContext";
import { useContentful } from "../../hooks";
const EXPANDED_MAP_SRC = '/assets/map_new_big.gif';

export const ArticleTitle = () => {
  return (
    <div>
      <div className='article-title-secondary-text tight-title'>
        SAVING THE WORLD IS NOW
      </div>
      <div className='article-title-main-text article-title-main-text-selected'>
        <div className='gold tight-title'>THE WORLD’S</div>
        <div className='aqua'>GREATEST GAME</div>
      </div>
    </div>
  );
};

export default function FooterMap() {
  
  const { setMapSrc } = useContext(AppContext);
  const { isLoading, articles } = useContentful();
  const onExpandMap = () => {
    setMapSrc(EXPANDED_MAP_SRC);
  };

  return (
    <FooterRoot>
      <ScreenFrameGrid>
        <MintArticle 
          imageAction={onExpandMap} 
          title={<ArticleTitle />} 
          logoBgColor='rgba(97, 211, 152, 1)' 
          logoUrl='/assets/leaf.svg' 
          preTitle='Make' 
          imageUrl='/assets/mint_solarpunk_article_header.png' 
          articleImageUrl='/assets/map_new.gif'
        >
          {renderRichText(articles['RWI'])}
        </MintArticle>
      </ScreenFrameGrid>
    </FooterRoot>
  )
}
